import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ReportsSelectDataElementTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.REPORTS_SELECT_DATA_ELEMENT;

	get id(): string {
		return TourId.REPORTS__SELECT_DATA_ELEMENT;
	}

	override get keyForPersistantDone(): string {
		return ReportsSelectDataElementTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.DOWN,
				allowStacked: false,
				attachTo: () => {
					return $(
						'div[role="menu"]:last-child .tox-collection__group div[title="New metric"]',
					).parent();
				},
			},
		];
	}
}
